import React, { useState } from "react";
import { TableCell, TableRow } from "@material-ui/core";
import { TableAction, TableWrapper, TableCellDefault } from "App/Component/ui";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useFetch, useDatatables } from "App/hooks";
import { headCells, ModalForm, RESET_STATE_TIPE_REGISTRASI } from "./helpers";
import { STYLE_DEFAULT_MASTER, TYPE_INSTANCE2 } from "App/constants";
import { LIST_URL_MASTER } from "utils/masters";

const useStyles = STYLE_DEFAULT_MASTER;

export default function TabKelasKamar() {
  const classes = useStyles();

  const [showModal, setShowModal] = useState(false);

  const [rows, setRows] = useFetch(
    TYPE_INSTANCE2,
    LIST_URL_MASTER.tipe_registrasi.list
  );

  const [formData, setFormData] = useState(RESET_STATE_TIPE_REGISTRASI);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "title",
    orderByRow: ["title", "code"],
  });

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      code: row?.code,
      title: row?.title,
      remark: row?.remark,
    });

    setShowModal(true);
  }

  // function clickDelete(row) {
  //   setFormData({
  //     ...formData,
  //     id: row?.id,
  //   });
  //   setShowModalDeleteConfirm(!showModalDeleteConfirm);
  // }

  return (
    <div className={classes.root}>
      {showModal && (
        <ModalForm
          setRows={setRows}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      <TableWrapper
        title='Daftar Tipe Registrasi'
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}>
                    <TableAction
                      isDelete={false}
                      clickUpdate={() => clickUpdate(row)}
                    />
                  </div>
                </TableCell>
                <TableCell align='left'>{row?.code}</TableCell>
                <TableCell align='left'>{row?.title}</TableCell>
                <TableCell align='left'>{row?.remark}</TableCell>
                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
}
